  <!-- Note: Do not use [disabled] on angular form controls
        check the method updateFormDisabledState() -->
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
    
    <p-toolbar>
      <ng-template #start>
        <div class="flex gap-4 toolbar-menu">
          <div class="flex flex-col">
            <label for="catalogNameFilter" class="text-sm font-medium">Name Filter</label>
            <input
              class="w-full relative z-[101]"
              pInputText
              (input)="filterGrades($event)"
              placeholder="Search"
            />
          </div>
          
          <app-scope-filter 
            [(selectedFilter)]="selectedScopeFilter"
            [userRoles]="userRoles"
            (filterChange)="onScopeFilterChange()">
          </app-scope-filter>
        </div>
      </ng-template>
    </p-toolbar>

    <form [formGroup]="catalogForm" novalidate>

      <ng-container formArrayName="items">
        <p-table
          #catalogTable
          styleClass="p-datatable-sm pr-2"
          [appAutoTableHeight]="true"
          [appAutoTableHeightContainerSelector]="'.grid-stack-item-content'"
          [appAutoTableHeightOffset]="90"
          (appAutoTableHeightChange)="tableHeight = $event"
          [scrollable]="true"
          [scrollHeight]="tableHeight"
          [virtualScroll]="!isLoading()"
          [virtualScrollItemSize]="32"
          [columns]="columnDefs"
          [resizableColumns]="true"
          showGridlines
          [value]="itemsCatalog.controls"
          dataKey="value.id"
          stateStorage="local"
          [stateKey]="componentId">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th class="text-sm text-center" style="width: 40px;"></th>
              @for (col of columns; track col.field) {
              <th pResizableColumn class="text-sm text-center">
                {{ col.header }}
              </th>
              }
              @if (userRoles?.catalogAdmin) {
              <th class="text-sm text-center">Scope</th>
              }
              <th class="text-center">
                <div style="display: flex;">
                  <p-button class="outlined-button" size="small" outlined="true" severity="success" [disabled]="itemsCatalog.invalid" icon="pi pi-plus"
                    (click)="onAddItem()" title="Add"></p-button>
                  <p-button size="small" severity="success" text [disabled]="itemsCatalog.invalid" icon="pi pi-file-excel"
                    (click)="exportExcel()" title="Export to Excel"></p-button>
                </div>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-itemFg let-rIdx="rowIndex">
            <ng-container [formGroupName]="rIdx">
            <tr class="hover:bg-gray-500 transition-colors duration-100"
              [class.catalog-duplicate-row]="duplicateRowColors().has(itemFg.get('id').value)"
              [style.background-color]="duplicateRowColors().get(itemFg.get('id').value) ?? null">
                <td class="text-center">
                  <app-catalog-metadata-icon [metadata]="itemFg.value.metadata"></app-catalog-metadata-icon>
                </td>
                <td>
                  <input type="text" pInputText formControlName="name"
                    (mouseenter)="setHoverTitle($event, !isControlInvalid(itemFg, 'name') ? showJson(itemFg.get('name').value) : getControlErrors(itemFg, 'name'))" 
                    autocomplete="off" />
                </td>
                <td>
                  <app-validated-number-input
                    [id]="'density'"
                    [control]="control(itemFg, 'density')"
                    [value]="control(itemFg, 'density').value"
                    [validation]="validationRules.density"
                    [isGrid]="true"
                  ></app-validated-number-input>
                </td>
                <td>
                  <app-validated-number-input
                    [id]="'specificHeatCapacity'"
                    [control]="control(itemFg, 'specificHeatCapacity')"
                    [value]="control(itemFg, 'specificHeatCapacity').value"
                    [validation]="validationRules.specificHeatCapacity"
                    [isGrid]="true"
                  ></app-validated-number-input>
                </td>
                <td>
                  <app-validated-number-input
                    [id]="'thermalConductivity'"
                    [control]="control(itemFg, 'thermalConductivity')"
                    [value]="control(itemFg, 'thermalConductivity').value"
                    [validation]="validationRules.thermalConductivity"
                    [isGrid]="true"
                  ></app-validated-number-input>
                </td>
                <td>
                  <app-validated-number-input
                    [id]="'youngsModulus'"
                    [control]="control(itemFg, 'youngsModulus')"
                    [value]="control(itemFg, 'youngsModulus').value"
                    [validation]="validationRules.youngsModulus"
                    [isGrid]="true"
                  ></app-validated-number-input>
                </td>
                <td>
                  <app-validated-number-input
                    [id]="'poissonsRatio'"
                    [control]="control(itemFg, 'poissonsRatio')"
                    [value]="control(itemFg, 'poissonsRatio').value"
                    [validation]="validationRules.poissonsRatio"
                    [title]="'Allowed range: 0 - 0.5'"
                    [isGrid]="true"
                  ></app-validated-number-input>
                </td>
                <td>
                  <app-validated-number-input
                    [id]="'thermalExpansionCoefficient'"
                    [control]="control(itemFg, 'thermalExpansionCoefficient')"
                    [value]="control(itemFg, 'thermalExpansionCoefficient').value"
                    [validation]="validationRules.thermalExpansionCoefficient"
                    [isGrid]="true"
                  ></app-validated-number-input>
                </td>
                @if (userRoles?.catalogAdmin) {
                <td class="flex justify-center">
                  @if (!itemFg.get('isLocked').value) {
                  <p-button
                    [label]="getScopeLabel(itemFg.get('scope').value)"
                    [severity]="itemFg.get('scope').value === CatalogScope.Global ? 'success' : 'info'"
                    size="small"
                    outlined="true"
                    class="outlined-button"
                    (click)="toggleScope(itemFg)"
                    [title]="'Click to switch to ' + (itemFg.get('scope').value === CatalogScope.User ? 'Global' : 'User')"
                  ></p-button>
                  } @else {
                  <span class="text-sm text-gray-500">Global</span>
                  }
                </td>
                }
                <td class="text-center">
                  @if (!deleteItemCheck(itemFg)) {
                  <i
                    class="pi pi-trash cursor-pointer !text-red-400"
                    (click)="onDeleteItem(rIdx)"
                    title="Delete"></i>
                  } @else {
                  <i
                    class="pi pi-lock text-gray-400"
                    title="Locked catalog item, cannot be deleted."></i>
                  }
                </td>
              </tr>
            </ng-container>
          </ng-template>
        </p-table>
      </ng-container>
    </form>
</app-tool-loader>